import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiManager from "../../api/ApiManager";
import { createGenericSlice } from "../createGenericSlice";

export type Categories = {
    categoryId: number | null;
    slug: string;
    name: string;
    subCategories?: Categories
}[]

export const fetchCategories = createAsyncThunk('site/fetchCategories', () => ApiManager.fetchCategories())

const initialState: Categories = [
    {
        categoryId: null,
        slug: '',
        name: ''
    }
]

const categoriesSlice = createGenericSlice<Categories>({
    name: 'categories',
    initialState: initialState,
    asyncThunk: fetchCategories,
})

export default categoriesSlice.reducer;